export default __webpack_public_path__ + "static/guest_user_policies_for_distribution_lists-ec7623ab342e6dedbce25971b7238015.svg";